/* Mobile product card: relocate the badge pill (top-left-container) out of the
   image overlay and into the info column so it sits in normal flow above the
   title (Figma). Restores the original position on desktop. */
(function () {
  var MOBILE = '(max-width: 767px)';
  var scheduled = false;

  function relocate() {
    scheduled = false;
    var mobile = window.matchMedia(MOBILE).matches;

    document.querySelectorAll('.pm-mobile-card').forEach(function (card) {
      var pill = card.querySelector('.top-left-container');
      if (!pill) return;

      if (mobile) {
        var info = card.querySelector('.card-info > div') || card.querySelector('.card-info');
        if (!info || pill.parentNode === info) return;
        // remember where it came from so desktop can restore it
        if (!pill.__pmOrigParent) {
          pill.__pmOrigParent = pill.parentNode;
          pill.__pmOrigNext = pill.nextSibling;
        }
        info.insertBefore(pill, info.firstChild);
      } else if (pill.__pmOrigParent && pill.parentNode !== pill.__pmOrigParent) {
        pill.__pmOrigParent.insertBefore(pill, pill.__pmOrigNext);
      }
    });
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(relocate);
  }

  document.addEventListener('DOMContentLoaded', schedule);
  window.addEventListener('load', schedule);
  window.addEventListener('resize', schedule);

  // badges are injected asynchronously on scroll; observe and relocate when they appear
  var mo = new MutationObserver(schedule);
  mo.observe(document.documentElement, { childList: true, subtree: true });

  schedule();
})();
